import { render } from "./MenuTableView3.vue?vue&type=template&id=f4757f4a&scoped=true"
import script from "./MenuTableView3.vue?vue&type=script&lang=js"
export * from "./MenuTableView3.vue?vue&type=script&lang=js"

import "./MenuTableView3.vue?vue&type=style&index=0&id=f4757f4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4757f4a"]])

export default __exports__